import {
  Table,
  TableBody,
  TableCell,
  TableColumn,
  TableHeader,
  TableRow,
} from '@heroui/table';

const ApiEndpoints = ({
  endpoints,
}: {
  endpoints: {
    category: string;
    method: string;
    path: string;
    description: string;
  }[];
}) => {
  const renderMethod = (method: string) => {
    switch (method) {
      case 'GET':
        return <span className="bg-[#DBEAFE] text-[#1447E6] px-2 py-1 rounded-sm">GET</span>;
      case 'POST':
        return <span className="bg-[#DCFCE7] text-[#008236] px-2 py-1 rounded-sm">POST</span>;
      case 'PUT':
        return <span className="bg-[#FEF9C2] text-[#A65F00] px-2 py-1 rounded-sm">PUT</span>;
      case 'DELETE':
        return <span className="bg-[#FFE2E2] text-[#C10007] px-2 py-1 rounded-sm">DELETE</span>;
      default:
        return method;
    }
  };

  return (
    <div className="overflow-hidden rounded-md border border-white/10 bg-gradient-to-r from-white/5 to-white/0">
      <Table
        removeWrapper
        aria-label="API Endpoints"
        classNames={{
          table: '!rounded-md !overflow-hidden',
          th: 'bg-white/10 text-white text-sm py-4 border-b border-white/10 !rounded-none',
          td: 'text-white/90 py-4 border-b border-white/10 !last:border-b-0',
        }}
      >
        <TableHeader>
          <TableColumn>Category</TableColumn>
          <TableColumn>Method</TableColumn>
          <TableColumn>Endpoint</TableColumn>
          <TableColumn>Description</TableColumn>
        </TableHeader>

        <TableBody emptyContent="No API endpoints found">
          {endpoints.map((item, index) => (
            <TableRow key={index}>
              <TableCell className="font-medium">{item.category}</TableCell>

              <TableCell>{renderMethod(item.method)}</TableCell>

              <TableCell>
                <code className="rounded bg-white/10 px-2 py-1 text-sm">
                  {item.path}
                </code>
              </TableCell>

              <TableCell className="max-w-xl">{item.description}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default ApiEndpoints;
